<template>
  <div class="main">
    <div class="login-container">
      <img alt="gefundn. Logo" src="../assets/images/logo-text-only.png">
      <h1>Passwort zurücksetzen</h1>
      <p v-if="msg" style="max-width: 400px;">{{msg}}</p>
      <LoadingSpinner v-if="checkingValidity" message="Token wird geprüft..."/>
      <div class="forgot-form" v-if="!checkingValidity && tokenValid">
          <table class="login-fields" v-if="!resetSuccessful">
            <tbody>
              <tr>
                <td><label for="email">Neues Passwort</label></td>
                <td><input type="password" id="email" v-model="credentials.password"></td>
              </tr>
              <tr>
                <td><label for="email">Wiederholen</label></td>
                <td><input type="password" id="email" v-model="credentials.password_repeat"></td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button class="login" @click="submit()" v-if="!resetSuccessful">Senden</button>
            <button class="login" v-if="resetSuccessful" @click="go_to_login()">Zum Login</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
  name: 'LoginView',
  data() {
    return {
      loginMode: true,
      checkingValidity: true,
      tokenValid: false,
      resetSuccessful: false,
      credentials: {
        password_repeat: null,
        password: null,
      },
      msg: null,
    };
  },
  components: {
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      console.error("not logged in!")
    } else {
      this.$router.push('/');
    }

    this.validateToken();
  },
  methods: {
    async validateToken(){
      let token = this.$route.query.t;

      if(!token) {
        this.msg = "Der angegebene Token ist ungültig.";
        this.checkingValidity = false;
        return;
      }

      let result = await AuthService.validateToken({token: token});
      this.checkingValidity = false;
      if(!result.success.success){
        this.msg = "Der angegebene Token ist ungültig.";
        this.checkingValidity = false;
        this.tokenValid = false;
      } else {
        this.checkingValidity = false;
        this.tokenValid = true;
      }
    },
    async submit(){
      console.log("firing submit")
      this.msg = null;

      if(!this.validateCredentials()){
        return false
      } else {
        try {
          let result = await AuthService.resetPassword({...this.credentials, token: this.$route.query.t});
          if(result.success){
            this.msg = "Passwort erfolgreich zurückgesetzt!"
            this.resetSuccessful = true;
          }
        } catch(e){
          console.error(e)
          this.msg = e.response.data
        }
      }
    },
    validateCredentials(){
      if(!this.credentials.password || !this.credentials.password_repeat){
        this.msg = "Bitte gib ein Passwort ein!"
        return false
      }

      if(this.credentials.password !== this.credentials.password_repeat){
        this.msg = "Passwörter stimmen nicht überein!"
        return false
      }

      return true
    },
    go_to_login() {
      this.$router.push("/login");
    }
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background: transparent;
}

.login-container {
  width: 100%;
  max-width: 380px;
  background: var(--card-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  padding: 40px 32px;
  box-shadow: var(--shadow-strong);
  text-align: center;
}

img {
  width: 220px;
  margin-bottom: 24px;
}

h1 {
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-bottom: 32px;
  color: var(--text-main);
}

.forgot-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-fields {
  width: 100%;
  text-align: left;
}

label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 8px 4px;
}

input {
  width: 100%;
  background: #F5F5F7;
  border: 1px solid transparent;
  padding: 14px 18px;
  border-radius: var(--radius-m);
  font-family: var(--font);
  font-size: 1rem;
  outline: none;
  box-sizing: border-box;
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

input:focus {
  background: white;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
}

.buttons {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

button.login {
  background: var(--primary-color);
  color: white;
  padding: 16px;
  border-radius: var(--radius-m);
  font-weight: 700;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
}
</style>
